'use client';
import Script from 'next/script';
import { useContext } from 'react';
import { gaScript } from '../../scripts/ga';
import { consentScript } from '../../scripts/consent';
import CookieBar from '../../scripts/cookie-bar';
import GlobalContext from '../../../context/global-context';
import useIsOverwolfIframe from '../../../hooks/use-is-overwolf-iframe';

// -----------------------------------------------------------------------------
export const HeaderScripts = (): JSX.Element => {
  const { config } = useContext(GlobalContext);
  const contentBase = config?.publicRuntimeConfig?.base?.contentBase;
  const { isOverwolfIframe } = useIsOverwolfIframe();

  return (
    <>
      <Script id='dct' src={`${contentBase}/dct/dct.js`}  />
      <Script id='consent-default' strategy='beforeInteractive'>
        {consentScript(isOverwolfIframe)}
      </Script>
      <Script id='google-analytics' strategy='beforeInteractive'>
        {gaScript}
      </Script>
      {/* Cookie bar self-suppresses inside the embedded Overwolf iframe flow. */}
      <CookieBar />
      <link rel='preload' href='/static_next/fonts/LatoLatin-Regular.woff2' crossOrigin='anonymous' as='font' type='font/woff2' />
    </>
  );
};